import { api } from "../Components/base_service";
import EnvDetails from "../Components/env_config";

const baseUrl = EnvDetails.getServerConfigs(); // dynamically gets correct environment URL

const ProductService = {
  getCategoriesByAlpabet: async (alphabet) => {
    try {
      const data = await api.get(`${baseUrl}api/product-categories/${alphabet}`);
      if (data.errorCode === "0" && Array.isArray(data.responseBody)) {
        return data.responseBody;
      }
      return [];
    } catch (err) {
      console.error("Product category fetch error:", err.message);
      return [];
    }
  },

  fetchProductsBySlug: async (slug) => {
    try {
      const data = await api.get(`${baseUrl}api/product/${slug}`);
      console.log("API Response:", data);
      if (data.errorCode === "0") {
        return { success: true, data: data.responseBody };
      } else {
        return {
          success: false,
          message: data?.errorMessage || "Failed to fetch product details",
        };
      }
    } catch (err) {
      console.error("Product fetch error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while fetching product details",
      };
    }
  },

  getProductCount: async () => {
    try {
      const data = await api.get(`${baseUrl}api/product/count`);
      console.log("API Response:", data);
      if (data.errorCode === "0") {
        return { success: true, count: data.responseBody.count };
      } else {
        return {
          success: false,
          message: data?.errorMessage || "Failed to fetch product count",
        };
      }
    } catch (err) {
      console.error("Product count fetch error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while fetching product count",
      };
    }
  },

  fetchProductDetailByCatalogNumber: async (catalogNumber) => {
    try {
      const data = await api.get(`${baseUrl}api/productdetail/${catalogNumber}`);
      console.log("API Response:", data);
      if (data.errorCode === "0") {
        return { success: true, data: data.responseBody };
      } else {
        return {
          success: false,
          message: data?.errorMessage || "Failed to fetch product details",
        };
      }
    } catch (err) {
      console.error("Product detail fetch error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while fetching product details",
      };
    }
  },

  searchProducts: async (query) => {
    try {
      const data = await api.get(`${baseUrl}api/search?query=${encodeURIComponent(query)}`);
      console.log("Search API Response:", data);
      if (data.errorCode === "0" && Array.isArray(data.responseBody)) {
        return { success: true, data: data.responseBody };
      } else {
        return {
          success: false,
          message: data?.errorMessage || "Failed to fetch search results",
        };
      }
    } catch (err) {
      console.error("Search fetch error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while fetching search results",
      };
    }
  },

  fetchProductByCasNo: async (casNo) => {
    try {
      const data = await api.get(`${baseUrl}api/productdetail/byCasNo?casNo=${encodeURIComponent(casNo)}`);
      console.log("CAS No API Response:", data);
      if (data.errorCode === "0") {
        return { success: true, data: data.responseBody };
      } else {
        return {
          success: false,
          message: data?.errorMessage || "No product found for the CAS number",
        };
      }
    } catch (err) {
      console.error("CAS No fetch error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while fetching CAS number details",
      };
    }
  },

  submitRFQ: async (rfqData) => {
    try {
      const data = await api.post(`${baseUrl}api/rfq`, rfqData);
      console.log("RFQ API Response:", data);
      if (data.errorCode === "0") {
        return { success: true, data: data.responseBody };
      } else {
        return {
          success: false,
          message: data?.errorMessage || "Failed to submit RFQ",
        };
      }
    } catch (err) {
      console.error("RFQ submission error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while submitting RFQ",
      };
    }
  },
};

export default ProductService;